const getDefaultOnBoardingState = () => {
    return {
        width: 9,
        step: 1,
        phoneNo: null,
        showIntermediateStep: false,
        dob: '1969-01-01',
        Aadhaar: null,
        Pan: null,
        Name: null,
        Email: null,
        'Bank Account Number': null,
        showBankDetails: false
    }
}
export const onBoarding = {
    namespaced: true,
    state: getDefaultOnBoardingState(),
    getters: {
        getCardDetails: (state) => {
            const cardContent = []
            cardContent.push({ label: 'Email', value: state.Email })
            cardContent.push({ label: 'Aadhaar', value: state.Aadhaar })
            cardContent.push({ label: 'Pan', value: state.Pan })
            cardContent.push({ label: 'Bank Account Number', value: state['Bank Account Number'] })

            return cardContent
        },
        getOnBoardingName: (state) => {
            return state.Name
        }
    },
    mutations: {
        setField (state, data) {
            state[data.field] = data.value
        },
        setStep (state, step) {
            state.step = step
        },
        incrementStep (state) {
            state.step++
        },
        decrementStep (state) {
            state.step--
        },
        reset (state) {
            const initialState = getDefaultOnBoardingState()
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key]
            })
        }
    },
    actions: {
        setField ({ commit }, data) {
            commit('setField', data)
        },
        setStep ({ commit }, step) {
            commit('setStep', step)
        },
        incrementStep ({ commit }, data) {
            commit('incrementStep', data)
        },
        decrementStep ({ commit }, step) {
            commit('decrementStep', step)
        }
    }
}
